/* =====================================================
   ZYVORA SKINCARE — THEME JS
   ===================================================== */

(function() {
  'use strict';

  /* ── Cart State ── */
  let cartData = { items: [], total_price: 0 };

  /* ── DOM Ready ── */
  document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    initMobileMenu();
    initCartDrawer();
    initAccordions();
    initFAQ();
    initForms();
    initGallery();
    fetchCart();
  });

  /* ── Header scroll effect ── */
  function initHeader() {
    const header = document.querySelector('.zv-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ── Mobile Menu ── */
  function initMobileMenu() {
    const btn = document.querySelector('.zv-hamburger');
    const menu = document.querySelector('.zv-mobile-menu');
    const close = document.querySelector('.zv-mobile-close');
    if (!btn || !menu) return;
    btn.addEventListener('click', () => menu.classList.add('open'));
    if (close) close.addEventListener('click', () => menu.classList.remove('open'));
    menu.addEventListener('click', function(e) {
      if (e.target === menu) menu.classList.remove('open');
    });
  }

  /* ── Fetch Cart ── */
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        cartData = data;
        updateCartUI();
      });
  }

  /* ── Update Cart UI ── */
  function updateCartUI() {
    const count = cartData.item_count || 0;
    const countEls = document.querySelectorAll('.zv-cart-count');
    countEls.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    renderCartItems();
    renderCartSubtotal();
  }

  function formatMoney(cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
  }

  /* ── Cart Drawer ── */
  function initCartDrawer() {
    const overlay = document.querySelector('.zv-cart-overlay');
    const drawer = document.querySelector('.zv-cart-drawer');
    const closeBtn = document.querySelector('.zv-cart-close');
    const continueBtn = document.querySelector('.zv-cart-continue');
    const cartBtns = document.querySelectorAll('[data-open-cart]');
    const checkoutBtn = document.querySelector('.zv-cart-checkout');

    function openCart() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
    function closeCart() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (overlay) overlay.addEventListener('click', closeCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (continueBtn) continueBtn.addEventListener('click', closeCart);
    cartBtns.forEach(btn => btn.addEventListener('click', openCart));

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function() {
        window.location.href = '/checkout';
      });
    }

    /* Add to Cart forms */
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form.classList.contains('zv-card-form') && !form.id === 'zv-product-form') return;
      if (!form.querySelector('input[name="id"]')) return;
      e.preventDefault();

      const id = form.querySelector('input[name="id"]').value;
      const qty = form.querySelector('input[name="quantity"]')?.value || 1;
      const btn = form.querySelector('button[type="submit"]');

      if (btn) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: parseInt(qty) })
      })
      .then(r => r.json())
      .then(function() {
        fetchCart();
        openCart();
        showNotify('Added to cart!');
      })
      .catch(function() {
        showNotify('Something went wrong. Please try again.');
      })
      .finally(function() {
        if (btn) {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }
      });
    });
  }

  /* ── Render Cart Items ── */
  function renderCartItems() {
    const container = document.querySelector('.zv-cart-items');
    if (!container) return;

    if (!cartData.items || cartData.items.length === 0) {
      container.innerHTML = `
        <div class="zv-cart-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          <h4>Your cart is empty</h4>
          <p>Discover your perfect skincare ritual</p>
        </div>`;
      return;
    }

    container.innerHTML = cartData.items.map(item => `
      <div class="zv-cart-item" data-key="${item.key}">
        <div class="zv-cart-item-img">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
        </div>
        <div class="zv-cart-item-info">
          <p class="zv-cart-item-title">${item.product_title}</p>
          <p class="zv-cart-item-price">${formatMoney(item.final_line_price)}</p>
          <div class="zv-qty-row">
            <button class="zv-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" onclick="zvQty(this)">−</button>
            <span class="zv-qty-num">${item.quantity}</span>
            <button class="zv-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" onclick="zvQty(this)">+</button>
          </div>
        </div>
        <button class="zv-cart-remove" data-key="${item.key}" onclick="zvRemove(this)">Remove</button>
      </div>
    `).join('');
  }

  /* ── Render Cart Subtotal ── */
  function renderCartSubtotal() {
    const el = document.querySelector('.zv-cart-total-price');
    if (el) el.textContent = formatMoney(cartData.total_price || 0);

    const freeShip = document.querySelector('.zv-cart-free-ship');
    if (freeShip) {
      freeShip.textContent = '🚚 Free delivery on your order!';
      freeShip.style.color = '#3C151D';
      freeShip.style.fontWeight = '500';
    }
  }

  /* ── Cart Actions (global) ── */
  window.zvQty = function(btn) {
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty);
    if (qty < 0) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(data => {
      cartData = data;
      updateCartUI();
    });
  };

  window.zvRemove = function(btn) {
    const key = btn.dataset.key;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(r => r.json())
    .then(data => {
      cartData = data;
      updateCartUI();
      showNotify('Item removed from cart');
    });
  };

  /* ── Accordions ── */
  function initAccordions() {
    document.querySelectorAll('.zv-acc-trigger').forEach(btn => {
      btn.addEventListener('click', function() {
        const item = this.closest('.zv-acc-item');
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.zv-acc-item.open').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── FAQ ── */
  function initFAQ() {
    document.querySelectorAll('.zv-faq-q').forEach(btn => {
      btn.addEventListener('click', function() {
        const item = this.closest('.zv-faq-item');
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.zv-faq-item.open').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── Product Gallery ── */
  function initGallery() {
    const thumbs = document.querySelectorAll('.zv-thumb');
    const mainImg = document.querySelector('.zv-gallery-main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const src = this.dataset.src;
        if (src) mainImg.src = src;
      });
    });
  }

  /* ── Forms ── */
  function initForms() {
    /* Newsletter */
    document.querySelectorAll('.zv-nl-form').forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]').value;
        if (!email) return;
        showNotify('Thank you for subscribing!');
        form.reset();
      });
    });

    /* Contact form */
    const contactForm = document.querySelector('.zv-contact-form-el');
    if (contactForm) {
      contactForm.addEventListener('submit', function(e) {
        e.preventDefault();
        showNotify('Message sent! We\'ll reply within 24 hours.');
        contactForm.reset();
      });
    }
  }

  /* ── Notification Toast ── */
  function showNotify(msg) {
    let el = document.querySelector('.zv-notify');
    if (!el) {
      el = document.createElement('div');
      el.className = 'zv-notify';
      el.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span></span>`;
      document.body.appendChild(el);
    }
    el.querySelector('span').textContent = msg;
    el.classList.add('show');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('show'), 3500);
  }

  /* ── Lazy load animation ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.zv-section, .zv-product-card, .zv-combo-card, .zv-step, .zv-concern-item').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

})();

/* ═══════════════════════════════════
   HERO SLIDER
   ═══════════════════════════════════ */
(function() {
  var slides = document.querySelectorAll('.zv-slide');
  var dots   = document.querySelectorAll('.zv-dot');
  var prev   = document.querySelector('.zv-slider-prev');
  var next   = document.querySelector('.zv-slider-next');
  if (!slides.length) return;

  var current = 0;
  var timer;
  var INTERVAL = 5000;

  function goTo(n) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function() { goTo(current + 1); }, INTERVAL);
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); startTimer(); });
  });
  if (prev) prev.addEventListener('click', function() { goTo(current - 1); startTimer(); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); startTimer(); });

  // Touch swipe
  var startX = 0;
  var slider = document.querySelector('.zv-hero-slider');
  if (slider) {
    slider.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { goTo(dx < 0 ? current + 1 : current - 1); startTimer(); }
    }, { passive: true });
  }

  startTimer();
})();

/* ═══════════════════════════════════
   STICKY ATC — PRODUCT PAGE
   ═══════════════════════════════════ */
(function() {
  var mainAtc = document.querySelector('.zv-product-atc');
  if (!mainAtc) return;

  // Build sticky bar
  var title = document.querySelector('.zv-product-title');
  var price = document.querySelector('.zv-product-price');
  var variantInput = document.querySelector('#zv-product-form input[name="id"]');
  if (!title || !price || !variantInput) return;

  var bar = document.createElement('div');
  bar.className = 'zv-sticky-atc';
  bar.innerHTML =
    '<div class="zv-sticky-atc-inner">' +
    '<span class="zv-sticky-atc-title">' + title.textContent + '</span>' +
    '<span class="zv-sticky-atc-price">' + price.textContent + '</span>' +
    '<button class="zv-sticky-atc-btn">Add to Cart</button>' +
    '</div>';
  document.body.appendChild(bar);

  bar.querySelector('.zv-sticky-atc-btn').addEventListener('click', function() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantInput.value), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (typeof fetchCart === 'function') fetchCart();
      var overlay = document.querySelector('.zv-cart-overlay');
      var drawer  = document.querySelector('.zv-cart-drawer');
      if (overlay && drawer) {
        overlay.classList.add('open');
        drawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Show/hide on scroll past main ATC
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      bar.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0.1 });
  io.observe(mainAtc);
})();
